import dompurify from 'dompurify';

export default {
  methods: {
    sanitizeText(text) {
      return dompurify.sanitize(text);
    }
  }
};
